<template>
  <div id="follow">
    <!-- {{ clubs }} -->
    <template v-if="step == 1">
      <div class="title">{{ $t("miclive.follow.title") }}</div>
      <div class="list">
        <div
          v-for="item in followingTeams"
          class="item"
          @click="removeTeam(item)"
        >
          <cld-image
            class="logo"
            :publicId="item.club.shield"
            type="fetch"
            loading="lazy"
          >
            <cld-transformation
              height="100"
              radius="3"
              crop="fill"
              fetchFormat="auto"
            />
          </cld-image>

          <span class="name">{{ item.club.name }}</span>
          <span class="category">{{ item.team.category }}</span>
        </div>
        <div class="item add" @click="startProcess()">
          {{ $t("miclive.follow.add") }}
        </div>
      </div>
    </template>
    <template v-else-if="step == 2">
      <div class="title">{{ $t("miclive.follow.add_title") }}</div>
      <div class="searcher"><input v-model="search" type="text" /></div>

      <template v-if="search != ''">
        <div class="clubs">
          <div
            v-for="club in results"
            :key="club.id"
            class="item"
            @click="select(club.id)"
          >
            <cld-image
              class="logo"
              :publicId="club.shield"
              type="fetch"
              loading="lazy"
            >
              <cld-transformation
                height="100"
                radius="3"
                crop="fill"
                fetchFormat="auto"
              />
            </cld-image>
            <!-- <img class="logo" :src="club.shield" /> -->
            <span class="name">{{ club.name }}</span>
          </div>
        </div>
      </template>
      <div
        class="button"
        @click="
          step = 1;
          search = '';
        "
      >
        {{ $t("miclive.ui.cancel") }}
      </div>
    </template>

    <template v-else-if="step == 3">
      <div
        class="back"
        @click="
          step = 2;
          new_follow = false;
        "
      >
        <cld-image
          class="logo"
          :publicId="club.shield"
          type="fetch"
          loading="lazy"
        >
          <cld-transformation
            height="100"
            radius="3"
            crop="fill"
            fetchFormat="auto"
          />
        </cld-image>

        <span class="name">{{ club.name }}</span>
      </div>
      <div class="teams">
        <div
          v-for="team in club.teams"
          :key="team.id"
          class="item"
          :class="{
            selected: current[club.id] && current[club.id].includes(team.id)
          }"
          @click="follow(club.id, team.id)"
        >
          <span class="follow"></span>
          <span class="name"
            ><b>{{ team.category }}</b> | {{ team.name }}</span
          >
        </div>
      </div>
      <div class="button" @click="confirm()">
        {{ $t("miclive.ui.save") }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Follow",
  data() {
    return {
      step: 1,
      search: "",
      club: false,
      following: {},
      current: {},
      new_follow: false
    };
  },
  computed: {
    clubs() {
      return this.$store.getters["competition/getClubs"]();
    },
    results() {
      var results = [];
      var data = this.clubs;
      var searchInput = cleanString(this.search.trim().toLowerCase());

      if (searchInput == "") return data;

      for (var idx in data) {
        var item = data[idx];

        var name = cleanString(item.name.trim().toLowerCase());

        if (searchInput != "") {
          const searchRegex = new RegExp(searchInput, "g");
          if (name.match(searchRegex)) {
            results.push(item);
          }
        }
      }

      return results;
    },
    followingTeams() {
      var results = [];
      for (var clubId in this.following) {
        var teams = this.following[clubId];
        var club = this.clubs[clubId];

        if (club) {
          for (var idx in teams) {
            var teamId = teams[idx];
            var team = club.teams[teamId];
            var result = {
              club: club,
              team: team
            };
            results.push(result);
          }
        }
      }

      return results;
    }
  },
  methods: {
    startProcess() {
      this.step = 2;
      this.current = JSON.parse(JSON.stringify(this.following));
    },
    select(clubId) {
      this.step = 3;
      this.club = this.clubs[clubId];
      this.new_follow = {
        clubId: clubId,
        teams: []
      };
      for (var teamId in this.club.teams) {
        var team = this.club.teams[teamId];
        team.followed =
          this.following[clubId] &&
          Object.values(this.following[clubId]).includes(teamId);
        if (team.followed) {
          this.new_follow.teams.push(teamId);
        }
      }
    },
    arrayRemove(arr, value) {
      return arr.filter(function(ele) {
        return ele != value;
      });
    },
    follow(clubId, teamId) {
      var aux = JSON.parse(JSON.stringify(this.current));
      if (!aux[clubId]) {
        aux[clubId] = [];
      }
      console.log(aux);

      if (aux[clubId].includes(teamId)) {
        aux[clubId] = this.arrayRemove(aux[clubId], teamId);
      } else {
        aux[clubId].push(teamId);
      }
      this.current = aux;
    },
    confirm() {
      this.following = JSON.parse(JSON.stringify(this.current));
      //   this.following[this.new_follow.clubId] = this.new_follow.teams;

      this.$store.commit("competition/setFollowing", this.following);
      this.step = 1;
    },
    removeTeam(item) {
      var self = this;
      this.$popup.confirm(
        self.$t("miclive.follow.remove_title"),
        self.$t("miclive.follow.remove_message"),
        self.$t("miclive.ui.yes"),
        self.$t("miclive.ui.no"),
        function() {
          if (self.following[item.club.id]) {
            var idx = self.following[item.club.id].indexOf(item.team.id);
            self.following[item.club.id].splice(idx, 1);

            if (self.following[item.club.id].length == 0) {
              delete self.following[item.club.id];
            }
          }

          self.$store.commit("competition/setFollowing", self.following);
          self.following = JSON.parse(JSON.stringify(self.following));
        }
        // callSave: () => {
        //   var aux = JSON.parse(JSON.stringify(this.following));
        //   aux[item.club.id] = this.arrayRemove(aux[item.club.id], item.team.id);
        //   this.following = aux;
        //   this.$store.commit("competition/setFollowing", this.following);
        // }
      );

      //   if (this.following[item.club.id]) {
      //     var idx = this.following[item.club.id].indexOf(item.team.id);
      //     this.following[item.club.id].splice(idx, 1);
      //   }

      //   this.$store.commit("competition/setFollowing", this.following);
      //   this.following = JSON.parse(JSON.stringify(this.following));
    }
  },
  mounted() {
    if (localStorage.following) {
      this.following = JSON.parse(localStorage.following);
    }
  },
  created() {
    // this.$store.dispatch("competition/loadClubs").then(function() {});
  }
};
</script>

<style lang="scss" scoped>
#follow {
  max-width: 1000px;
  margin: 0 auto;
}
.list {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-gap: 10px;
  column-gap: 10px;
  row-gap: 10px;
  text-align: center;

  .item {
    background-color: #fff;
    color: #222;
    height: 150px;
    border-radius: 4px;
    padding: 20px 10px;
    align-items: center;
    display: flex;
    flex-direction: column;
    background-size: 25px;
    background-position: top 10px right 10px;
    background-image: url("~@/../public/img/star_selected.svg");
    background-repeat: no-repeat;
    background-color: #fff;

    &.add {
      background-size: 60px;
      background-position: center top 30px;
      background-image: url("~@/../public/img/add.svg");
      background-repeat: no-repeat;
      background-color: $secondary-color;
      padding-top: 100px;
    }

    .logo {
      height: 60px;
      margin-bottom: 10px;
    }
    .category {
      font-family: $font-title;
    }
    .name {
      font-family: $font-text;
      font-size: 14px;
    }
  }
}

.button {
  max-width: 450px;
  margin: 0 auto;
}

.searcher {
  background-size: 20px;
  background-position: center right 10px;
  background-image: url("~@/../public/img/search.svg");
  background-repeat: no-repeat;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 15px;
  background-color: #fff;
  text-align: left;
  input {
    width: calc(100% - 30px);
    height: 40px;
    border: none;
    outline: none;
    padding: 10px;
    font-size: 18px;
  }
}

.back {
  display: flex;
  align-items: center;
  width: fit-content;
  .logo {
    width: 25px;
    margin-left: 10px;
  }
  .name {
    padding-left: 10px;
    padding-right: 20px;
    font-family: $font-title;
    color: #222;
    font-size: 14px;
  }
}

.clubs {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-gap: 10px;
  margin-bottom: 15px;

  .item {
    background-size: 20px;
    background-position: center right 10px;
    background-image: url("~@/../public/img/left_arrow.svg");
    background-repeat: no-repeat;
    background-color: #fff;
    border-radius: 4px;
    width: 100%;
    padding: 10px;
    display: flex;
    align-items: center;

    .logo {
      width: 15%;
    }
    .name {
      width: 85%;
      padding-left: 10px;
      padding-right: 20px;
      font-family: $font-title;
    }
  }
}

.teams {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-gap: 10px;
  margin-bottom: 15px;

  .item {
    background-color: #fff;
    border-radius: 4px;
    width: 100%;
    padding: 10px;
    display: flex;
    align-items: center;

    .follow {
      width: 25px;
      height: 25px;
      background-size: 25px;
      background-position: center;
      background-image: url("~@/../public/img/star.svg");
      background-repeat: no-repeat;
      background-color: #fff;
    }
    .name {
      width: calc(100% - 25px);
      padding-left: 10px;
      padding-right: 20px;

      b {
        font-family: $font-title;
      }
    }

    &.selected {
      .follow {
        background-image: url("~@/../public/img/star_selected.svg");
      }
    }
  }
}

.tablet {
  .clubs {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .teams {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .list {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.laptop {
  .clubs {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .teams {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .list {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.desktop {
  .clubs {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .teams {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .list {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
</style>
